// The video editor (components/Editor), one file per area so its strings are
// written and reviewed in pieces: t('editor.rve.<area>.<key>')
import shell from './shell.ar.js';
import text from './text.ar.js';
import layers from './layers.ar.js';
import timeline from './timeline.ar.js';

export default { shell, text, layers, timeline };
